// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1o50z","tab":"ProcedureTabs_tab__3aWiV"};